/**
 * @deprecated Avoid using varname.escapeHtml() style and instead use "StringUtils.escapeHtml(varname)" as that doesn't pollute global scope.
 * When we can no longer CTRL+F for ".escapeHtml(" in our codebase, this logic should be moved to the StringUtils and then this should be deleted.
 * The custom_typings information should be deleted too.
 */
String.prototype.escapeHtml = function (): string {
	return (
		this &&
		(this + '').replace(
			/[&<>"'/]/g,
			(s) =>
				({
					'&': '&amp;',
					'<': '&lt;',
					'>': '&gt;',
					'"': '&quot;',
					"'": '&#x27;',
					'/': '&#x2F;',
				}[s]),
		)
	);
};

/**
 * @deprecated Avoid using varname.isNotBlank() style and instead use "StringUtils.isNotBlank(varname)" as that doesn't pollute global scope.
 * When we can no longer CTRL+F for ".isNotBlank(" in our codebase, this logic should be moved to the StringUtils and then this should be deleted.
 * The custom_typings information should be deleted too.
 */
String.prototype.isNotBlank = function (): boolean {
	return this && this.trim() !== '';
};

/**
 * @deprecated Avoid using varname.isBlank() style and instead use "StringUtils.isBlank(varname)" as that doesn't pollute global scope.
 * When we can no longer CTRL+F for ".isBlank(" in our codebase, this logic should be moved to the StringUtils and then this should be deleted.
 * The custom_typings information should be deleted too.
 */
String.prototype.isBlank = function (): boolean {
	return !this || this.trim() === '';
};
